module.exports = __webpack_public_path__ + "static/media/onboarding9.db0706ea.svg";